export const notificationTypes = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

/** @deprecated */
export default notificationTypes;
